import React from 'react';
import { Link } from 'react-router-dom';
import { GovCard } from '@gov-design-system-ce/react';
import { useLocale } from '@gov-nx/core/service';
import { PageCode, useRozcestnikContext } from '@gov-nx/module/page';
import { CardCarousel, LayoutGap } from '@gov-nx/ui/web';
import { truncate } from '@gov-nx/utils/common';
import { pageRouteResolver } from '@gov-nx/web';
import { MarkdownRender } from '../../Markdown/MarkdownRender';

export const HomepageFavoritesSection = () => {
	const { favoriteSignposts } = useRozcestnikContext();
	const code = PageCode['rozcestnik'];
	const { t } = useLocale(code);

	if (favoriteSignposts.length < 1) {
		return;
	}

	return (
		<section aria-labelledby="moje-oblibene">
			<CardCarousel
				headline={t('nadpis.moje-oblibene')}
				headlineId="moje-oblibene"
				showAllButton={t('akce.zobrazit-vse')}
				showAllButtonAria={t('akce.wcag.zobrazit-vse-oblibene')}
				showAllButtonUrl={pageRouteResolver('sluzby.oblibene')}
				arrowLeftAria={t('akce.posunout-zpet')}
				arrowRightAria={t('akce.posunout-vpred')}>
				{favoriteSignposts.map((signpost) => {
					const renderContent = (
						<LayoutGap gap="s">
							<h3 className="text-headline-s! text-(--text-primary-color)">
								{signpost.name}
							</h3>
							{signpost.description ? (
								<p className="mt-0!">
									<MarkdownRender>
										{truncate(signpost.description, 150)}
									</MarkdownRender>
								</p>
							) : null}
						</LayoutGap>
					);

					return (
						<li
							key={signpost.id}
							className="snap-start flex-[0_0_18.75rem]">
							<GovCard asChild>
								{signpost.action.isLink ? (
									<Link to={signpost.action.to}>{renderContent}</Link>
								) : (
									<button
										aria-label={t('wcag.zobrazit-sluzbu') + signpost.name}
										onClick={signpost.action.onClick}
										className="text-left">
										{renderContent}
									</button>
								)}
							</GovCard>
						</li>
					);
				})}
			</CardCarousel>
		</section>
	);
};
